export const GENDERS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Non-binary", label: "Non-binary" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const SEXUAL_ORIENTATIONS = [
  { value: "Heterosexual", label: "Heterosexual" },
  { value: "Homosexual", label: "Homosexual" },
  { value: "Bisexual", label: "Bisexual" },
  { value: "Asexual", label: "Asexual" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const MARITAL_STATUSES = [
  { value: "Single", label: "Single" },
  { value: "In a relationship", label: "In a relationship" },
  { value: "Married", label: "Married" },
  { value: "Divorced", label: "Divorced" },
  { value: "Widowed", label: "Widowed" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const INTERESTS = [
  "Travel",
  "Cooking",
  "Sports",
  "Reading",
  "Music",
  "Art",
  "Technology",
  "Gaming",
  "Fitness",
  "Photography",
  "Writing",
  "Movies",
  "Fashion",
  "Volunteering",
  "Nature",
];
